import React from "react";
import PropTypes from "prop-types";
import { IonButton, IonList } from "@ionic/react";

function ServicePhase({ isSecondService = false, onAction, currentStatus }) {
  const handleService = async (serviceType) => {
    const { current_player } = currentStatus;
    const { athleteId } = current_player;
    onAction(serviceType, { athleteId });
  };
  return (
    <div
      className="ion-padding"
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "350px",
        textAlign: "center",
        justifyContent: "center",
        margin: "0 auto",
      }}
    >
      <IonButton
        size="large"
        expand="full"
        onClick={() => handleService("valid_service")}
        color={"success"}
      >
        Valido
      </IonButton>
      <IonButton
        size="large"
        expand="full"
        color={isSecondService ? "danger" : "warning"}
        onClick={() =>
          handleService(isSecondService ? "double_fault" : "fault")
        }
      >
        {isSecondService ? "Doppio Fallo" : "Fallo"}
      </IonButton>
      <IonButton
        size="large"
        expand="full"
        onClick={() => handleService("ace")}
      >
        ACE
      </IonButton>
    </div>
  );
}

ServicePhase.propTypes = {
  isSecondService: PropTypes.bool,
  onAction: PropTypes.func,
  currentStatus: PropTypes.object,
};

export default ServicePhase;
